export default __webpack_public_path__ + "static/tour-preview-btn-small-7d0a07e22893d3b6fa652d548b490862.png";